// extracted by LIB_CSS_EXTRACT_LOADER
import "./aspect-ratio_module.css"
export default {"root":"root-x8J8rK"};